/*
 * The bracelet product page.
 *
 *   tiers     a tier tile sets the form's hidden quantity input and swaps
 *             the main price for the tier's total. Every figure it shows was
 *             rendered by Liquid (the tile carries its own money_with_currency
 *             total); nothing is computed here. The discount itself is a
 *             Shopify automatic discount, and the cart is where it applies.
 *   designs   the 2x / 3x tiles carry one <select> per bracelet. On submit
 *             with such a tier, the chosen designs go to /cart/add.js as ONE
 *             call with one line per design (same design twice = quantity 2),
 *             so the drawer opens once with everything. The quantity-based
 *             discount is on the collection, so mixing still earns it.
 *   gift box  (block optional) ticked, its variant rides along in the same
 *             call. Never pre-ticked.
 *
 * With tier 1 and no gift the theme's own submit runs untouched. The
 * mechanics of the multi-item path -- sections re-render, drawer opener,
 * cart:refresh -- are the ones product-fbt-bundle.js uses for the case
 * bundles; a failure falls back to a plain form submit (which adds the tier
 * quantity of this product), so nothing can strand the customer.
 *
 * Event delegation throughout: the theme re-renders every product block on
 * a variant change, and elements bound directly would go with them.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------- tiers -- */

  function qtyInput() { return document.querySelector('[data-bracelet-qty]'); }

  function checkedTier() {
    var r = document.querySelector('[data-bracelet-tier]:checked');
    var n = r ? parseInt(r.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function selectedTile() {
    var r = document.querySelector('[data-bracelet-tier]:checked');
    return r ? r.closest('.bracelet-tier') : null;
  }

  // The main price, in the same section as the tiers. Its first innerHTML
  // is remembered so tier 1 restores exactly what Liquid rendered.
  function priceEl(tiers) {
    var section = tiers.closest('[id^="shopify-section-"]') || document;
    return section.querySelector('.product-price__current-price');
  }

  function syncPrice(tiers, tile, tier) {
    var el = priceEl(tiers);
    if (!el) return;
    if (!el.hasAttribute('data-bracelet-original')) {
      el.setAttribute('data-bracelet-original', el.innerHTML);
    }
    var total = tile && tile.querySelector('[data-bracelet-tier-total]');
    if (tier > 1 && total) {
      el.innerHTML = total.innerHTML;
      el.setAttribute('data-bracelet-tier-price', String(tier));
    } else {
      el.innerHTML = el.getAttribute('data-bracelet-original');
      el.removeAttribute('data-bracelet-tier-price');
    }
  }

  function syncTier(radio) {
    var tiers = radio.closest('[data-bracelet-tiers]');
    if (!tiers) return;
    var qty = parseInt(radio.value, 10);
    if (!(qty > 0)) qty = 1;
    var input = qtyInput();
    if (input) input.value = String(qty);
    var tiles = tiers.querySelectorAll('.bracelet-tier');
    var selected = null;
    for (var i = 0; i < tiles.length; i++) {
      var r = tiles[i].querySelector('[data-bracelet-tier]');
      var on = !!(r && r.checked);
      tiles[i].classList.toggle('is-selected', on);
      if (on) selected = tiles[i];
    }
    syncPrice(tiers, selected, qty);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-bracelet-tier')) syncTier(t);
  });

  // After the theme re-renders the blocks the tiles come back with "1"
  // selected and the hidden input at 1 -- consistent with each other, which
  // is what matters. This just makes sure they agree on first paint too.
  function syncOnLoad() {
    var checked = document.querySelector('[data-bracelet-tier]:checked');
    if (checked) syncTier(checked);
  }

  /* --------------------------------------------------------- designs -- */

  // The chosen designs of the selected tier, as cart items: one line per
  // distinct variant, in the order the customer picked them.
  function designItems(fallbackId, tier) {
    var tile = selectedTile();
    var slots = tile ? tile.querySelectorAll('[data-bracelet-slot]') : [];
    var items = [], index = {};
    var add = function (id) {
      if (!id) return;
      if (index[id] === undefined) { index[id] = items.length; items.push({ id: id, quantity: 1 }); }
      else items[index[id]].quantity += 1;
    };
    if (slots.length) {
      for (var i = 0; i < slots.length; i++) {
        var picked = slots[i].querySelector('[data-bracelet-choice]:checked');
        add(picked ? picked.value : fallbackId);
      }
    } else {
      for (var n = 0; n < tier; n++) add(fallbackId);
    }
    return items;
  }

  /* -------------------------------------------------------- gift box -- */

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function openCartDrawer() {
    var openers = document.querySelectorAll('[data-sidebar-id="CartDrawer"]');
    var opened = false;
    for (var i = 0; i < openers.length; i++) {
      if (!opened && openers[i].offsetParent !== null) { openers[i].click(); opened = true; }
    }
    if (!opened && openers[0]) openers[0].click();
  }

  function refreshDrawer(sectionId, sections) {
    if (!sectionId || !sections || !sections[sectionId]) return;
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sections[sectionId];
    var inner = tmp.querySelector('#shopify-section-' + sectionId);
    wrap.innerHTML = inner ? inner.innerHTML : sections[sectionId];
  }

  // The line-item properties and selling plan the form carries, if any, so
  // the multi-item path loses nothing the single-item path would send.
  function formExtras(form) {
    var fd = new FormData(form);
    var extras = {};
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && String(value).trim()) props[m[1]] = value;
    });
    if (Object.keys(props).length) extras.properties = props;
    var sp = fd.get('selling_plan');
    if (sp) extras.selling_plan = sp;
    return extras;
  }

  function addToCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') : null;
    var body = { items: items };
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || 'add failed');
        }
        refreshDrawer(sectionId, res.data.sections);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return res.data;
      });
  }

  function giftChoice() {
    var box = document.querySelector('[data-bracelet-gift-input]');
    if (!box || !box.checked) return null;
    var id = box.getAttribute('data-variant-id') || box.value;
    return id ? { id: id, quantity: 1 } : null;
  }

  // Capture phase, so it runs before the theme's own submit handler.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.querySelector('[data-bracelet-tiers]')) return;   // not this page
    // only the product form the tiles belong to (the hidden quantity input
    // names it): other add buttons on the page, like the cart drawer's
    // "Usually bought together", add their own item at their own quantity.
    // getAttribute, not form.id: a product form has an input named "id",
    // and form.id returns that input.
    var q = qtyInput();
    if (q && q.getAttribute('form') && form.getAttribute('id') !== q.getAttribute('form')) return;
    if (form.__fbtBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }   // an add is in flight
    var tier = checkedTier();
    var gift = giftChoice();
    var fd = new FormData(form);
    var currentId = fd.get('id');
    if (!currentId) return;
    // a CreedLink takes its free parts along in the same add
    // (assets/creedlink-gifts.js), which needs this JSON path even for one
    var withParts = !!(window.scGifts && window.scGifts.buy.indexOf(Number(currentId)) > -1);
    if (tier <= 1 && !gift && !withParts) return;      // the theme does its thing

    var items = tier > 1 ? designItems(currentId, tier) : [{ id: currentId, quantity: 1 }];
    var extras = formExtras(form);
    for (var i = 0; i < items.length; i++) {
      if (extras.properties) items[i].properties = extras.properties;
      if (extras.selling_plan) items[i].selling_plan = extras.selling_plan;
    }
    if (gift) items.push(gift);

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[name="add"]');
    form.__fbtBusy = true;
    if (btn) { btn.classList.add('loading'); btn.classList.add('is-loading'); btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function release() {
      form.__fbtBusy = false;
      if (btn) { btn.classList.remove('loading'); btn.classList.remove('is-loading'); btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
    addToCart(items)
      .then(function () { release(); })
      .catch(function () {
        release();
        form.submit();                                  // the plain flow, never a dead end
      });
  }, true);

  /* ------------------------------------------------------------ boot -- */

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncOnLoad);
  else syncOnLoad();
  document.addEventListener('shopify:section:load', syncOnLoad);
})();
